// src/components/pages/segment/SegmentListing.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchSegments, createSegment, deleteSegment, publishSegment, copySegment } from "../../../../redux/actions/journeyAction";
import { SET_SEGMENT_CURRENT_PAGE, SET_SEGMENT_ITEMS_PER_PAGE } from "../../../../constants/ActionTypes";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Page from "../../../Page";
import { toast } from "react-toastify";
import Pagination from "../../../../components/shared/Pagination";
//import DynamicFilters from "./DynamicFilters";

const SegmentListing = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = props.authToken;
  
  // Get segments from the correct Redux state (journey, not segment)
  const segments = useSelector((state) => state.journey.segments || []);

  const segmentsLoading = useSelector((state) => state.journey.segments_loading || false);
  const segmentsError = useSelector((state) => state.journey.segments_error || null);
  const currentPage = useSelector((state) => state.journey.segment_pagination?.currentPage || 1);
  const totalPages = useSelector((state) => state.journey.segment_pagination?.totalPages || 1);
  const totalItems = useSelector((state) => state.journey.segment_pagination?.totalItems || 0);
  const itemsPerPage = useSelector((state) => state.journey.segment_pagination?.itemsPerPage || 10);
  
  console.log("Segment pagination state:", { currentPage, totalPages, totalItems, itemsPerPage });
  console.log("Segments count:", segments.length);

  const [showSegmentDialog, setShowSegmentDialog] = useState(false);
  const [segmentName, setSegmentName] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [segmentToDelete, setSegmentToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [segmentToPublish, setSegmentToPublish] = useState(null);
  const [selectedDataSource, setSelectedDataSource] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [datadetails, setdatadetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [creating, setCreating] = useState(false);
  const [copyingId, setCopyingId] = useState(null);
  
  
  // Fetch segments when component mounts or pagination changes (not search)
  useEffect(() => {
    if (authToken) {
      dispatch(fetchSegments(authToken, currentPage, itemsPerPage, searchTerm));
    }
  }, [authToken, dispatch, currentPage, itemsPerPage]);

  // Debounced search effect - only when searchTerm changes
  useEffect(() => {
    if (authToken) {
      const timeoutId = setTimeout(() => {
        dispatch(fetchSegments(authToken, 1, itemsPerPage, searchTerm));
      }, 500); // 500ms debounce

      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm, authToken, dispatch, itemsPerPage]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Get channel options based on selected data source
  const getChannelOptions = () => {
    if (selectedDataSource === "My DB") {
      return [
        { value: "My List", label: "My List" },
        { value: "My Contact List", label: "My Contact List" }
      ];
    } else if (selectedDataSource === "channel_partner") {
      return [
        { value: "AllPartners", label: "All Partners" },
        { value: "PartnerLeads", label: "Partner Leads" },
        { value: "Contacts", label: "Partner Contacts" }
      ];
    }
    return [];
  };

  // Reset channel when data source changes
  const handleDataSourceChange = (e) => {
    setSelectedDataSource(e.target.value);
    setSelectedChannel(""); // Reset channel when data source changes
  };

  // Debounced search function
  const handleSearch = (searchValue) => {
    if (authToken) {
      dispatch(fetchSegments(authToken, 1, itemsPerPage, searchValue));
    }
  };

  // Debounce search input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handleSearch(searchTerm);
    }, 500); // 500ms delay

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  
  const handleEditClick = (segment) => {
    // if (isJourneyPublishedOrScheduled(journey)) {
    //   setJourneyToUnpublishWarning(journey);
    //   setPendingAction('edit');
    //   setUnpublishWarningModalOpen(true);
    // } else {
    //   navigate(`/segment/edit/${segment.id}`);
    // }

    navigate(`/segment/edit/${segment.id}`);
  };

  const confirmDelete = (seg) => {
    setSegmentToDelete(seg);
    setShowDelete(true);
  };

  const handleSubmitSegment = async () => {
       
    if (!segmentName) {
      toast.error("Please select segment name");
      return;
    }
    if (!selectedDataSource) {
      toast.error("Please select data source");
      return;
    }
    if (!selectedChannel) {
      toast.error("Please select a channel");
      return;
    }
    try {
      if (creating) return;
      setCreating(true);
      const segmentData = {
        action: 'create',
        id: null,
        segment_name: segmentName,
        partner_category: null, // selectedPartners already contains the IDs
        master_data_list: null,
        channel: selectedChannel || '',
        source: selectedDataSource || '',
        filters: null,
        page_name:'segment'
      };
      const createdSegmentName = segmentData.segment_name;
      const response = await dispatch(createSegment(authToken, segmentData));
      
      // Check if segment was created successfully and get the segment ID
      if (response && response.success && response.payload && response.payload.details) {
        const segmentId = response.payload.details;
        sessionStorage.setItem('newlyCreatedSegment', createdSegmentName);
        
        // Close modal and reset form
        setShowSegmentDialog(false);
        setSegmentName("");
        setSelectedDataSource("");
        setSelectedChannel("");
        
        // Refresh segments list
        await dispatch(fetchSegments(authToken, currentPage, itemsPerPage));
        
        // Redirect to edit page
        navigate(`/segment/edit/${segmentId}`);
      } else {
        toast.error("Failed to create segment");
      }
         } catch (error) {
       toast.error("Failed to create segment");
     } finally {
       setCreating(false);
     }
  };

  const handleDeleteConfirm = async () => {
    if (segmentToDelete && authToken) {
      try {
        setDeleting(true);
        const response = await dispatch(deleteSegment(authToken, segmentToDelete.id));
        
        // Check if the delete was successful
        if (response && response.success) {
          // Success toast is handled inside the action; just refresh list and close modal
          await dispatch(fetchSegments(authToken, currentPage, itemsPerPage, searchTerm)); // fetch updated list after deletion
          setShowDelete(false);
          setSegmentToDelete(null);
          setDeleting(false);
        } else {
          // Delete failed, error message already shown by the action
          console.error("Delete failed:", response?.error);
          setDeleting(false);
        }
      } catch (error) {
        toast.error("Failed to Segment Deleted.");
        console.error("Delete error:", error);
        setDeleting(false);
      }
    }
  };

    const handlePublishClick = async (datadetails) => {
     if ( datadetails && authToken) {
       try {
         const publish = datadetails.master_data_list == 0 ? 'draft' : 'active';
         const response = await dispatch(publishSegment(authToken, datadetails.id,publish));
         if (response && response.success) {
           await dispatch(fetchSegments(authToken,currentPage, itemsPerPage, searchTerm));
         } else {
           toast.error(response.error);
         }
       } catch (error) {
         toast.error("Failed to publish segment1");
       }
     }
    };

   const handleCopySegment = async (datadetails) => {
     if(datadetails && authToken) {
      try {
        setCopyingId(datadetails.id);
        const response = await dispatch(copySegment(authToken, datadetails.id));
        if (response && response.success) {
          await dispatch(fetchSegments(authToken,currentPage, itemsPerPage, searchTerm));
        }
      } catch (error) {
        // toast handled in action
      } finally {
        setCopyingId(null);
      }
     }
   };

  // Pagination handlers
  const handlePageChange = (page) => {
    dispatch({ type: SET_SEGMENT_CURRENT_PAGE, payload: page });
    dispatch(fetchSegments(authToken, page, itemsPerPage, searchTerm));
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    dispatch({ type: SET_SEGMENT_ITEMS_PER_PAGE, payload: newItemsPerPage });
    dispatch({ type: SET_SEGMENT_CURRENT_PAGE, payload: 1 }); // Reset to page 1 when changing items per page
    dispatch(fetchSegments(authToken, 1, newItemsPerPage, searchTerm));
  };

  const handleApplyFilters = (filters) => {
    setAppliedFilters(filters);
    console.log("Applied filters:", filters);
    // Here you can implement the logic to apply filters to your API call
    // For now, we'll just log the filters
  };


  props.pageTypeHandler("Segment");
 
  return (
    <>
      <style>{`.header-div div { margin-top: 0px !IMPORTANT; }`}</style>
      <div className="container mt-4 maindiv">
      <div className="container-fluid mt-4">
        {/* Header */}
        <Row className="mb-3">
          <Col>
            <h2 className="mb-0">Segments</h2>
          </Col>
                     <Col xs="auto">
             <Button 
               variant="primary" 
               onClick={() => setShowSegmentDialog(true)}
               className="d-flex align-items-center gap-2 me-2"
             >
               <Icon.Plus /> New Segment
             </Button>
             
           </Col>
        </Row>
        
        {/* Search Bar and Filters */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ paddingLeft: '40px' }}
              />
              <Icon.Search 
                className="position-absolute"
                style={{ 
                  left: '12px', 
                  top: '50%', 
                  transform: 'translateY(-50%)',
                  color: '#6c757d'
                }}
                size={16}
              />
            </div>
          </Col>
          
        </Row>
      </div>

      <Page title="Segments">
        {/* Table Header */}
        <div className="row fw-bold border-bottom py-2 bg-light">
          <div className="col-2">Sr.No</div>
          <div className="col-6">Name</div>
          {/* <div className="col-2">Data Source</div> */}
          <div className="col-2">Channel</div>
          <div className="col-2 text-end text-muted">Actions</div>
        </div>

        {/* Table Data */}
        {segmentsError && (
          <div className="text-center py-3 text-danger">
            Error loading segments: {segmentsError}
          </div>
        )}
        {segmentsLoading ? (
          <div className="text-center py-3">Loading segments...</div>
        ) : segments && segments.length > 0 ? (
          segments.map((segment, index) => (
            <div key={segment.id} className="row align-items-center border-bottom py-2">
              <div className="col-2">
               <span>{index + 1}</span >
              </div>
              <div className="col-6">
                <div 
                  className="fw-medium cursor-pointer"
                  onClick={() => handleEditClick(segment)}
                  style={{ cursor: 'pointer' }}
                >
                  {segment.segment_name || segment.name}
                </div>
              </div>
              {/* <div className="col-2">
                <span className="badge bg-info">{segment.master_data_list?.length || 0} Items</span>
              </div> */}
              <div className="col-2">
              {segment.channel || segment.channel || ''}
              </div>
             
              <div className="col-2 d-flex justify-content-end text-muted" style={{ fontSize: "0.875rem" }}>
                <span 
                    className="me-3" 
                    title={segment.status === 'active' ? "Published - Click to unpublish" : "Unpublished - Click to publish"}
                    onClick={() => {
                      handlePublishClick(segment);
                    }}
                  >
                    {segment.master_data_list != 0 ? (
                      <Icon.Clock className="cursor-pointer text-warning" />
                    ) : (
                      <Icon.CheckCircle className="cursor-pointer text-success" />
                    )}
                  </span>
                                 <span 
                   className="me-3" 
                   onClick={() => handleEditClick(segment)} 
                   title="Edit Segment"
                 >
                   <Icon.PencilSquare className="cursor-pointer" />
                 </span>
                 <span 
                   className="me-3" 
                   onClick={() => copyingId ? null : handleCopySegment(segment)} 
                   title="Copy Segment"
                   style={{ opacity: copyingId === segment.id ? 0.6 : 1, pointerEvents: copyingId ? 'none' : 'auto' }}
                 >
                   {copyingId === segment.id ? (
                     <span className="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
                   ) : (
                     <Icon.Copy className="cursor-pointer" />
                   )}
                 </span>
                <span 
                  className="cursor-pointer" 
                  onClick={() => confirmDelete(segment)} 
                  title="Segment Deleted."
                >
                  <Icon.Trash />
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-3">
            {searchTerm ? `No segments found matching "${searchTerm}"` : "No segments found"}
          </div>
        )}

        {/* Pagination */}
        {!segmentsLoading && segments && segments.length > 0 && (
          <div style={{marginTop: '5px'}}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleItemsPerPageChange}
              showItemsPerPage={true}
              showInfo={true}
            />
          </div>
        )}

      </Page>


             {/* Create Segment Modal */}
       <Modal show={showSegmentDialog} onHide={() => {
         setShowSegmentDialog(false);
         setSegmentName("");
         setSelectedDataSource("");
         setSelectedChannel("");
       }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New Segment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-dark mb-2">
                    Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={segmentName}
                    onChange={(e) => setSegmentName(e.target.value)}
                    className="form-select-custom"
                    style={{ width: '100%', maxWidth: '100%' }}
                    placeholder="Enter name"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-dark mb-2">
                  Data Source
                  </Form.Label>
                  <Form.Select
                    value={selectedDataSource}
                    onChange={handleDataSourceChange}
                    className="form-select-custom"
                    style={{ width: '100%', maxWidth: '100%' }}
                  >
                    <option value="">Select Data Source</option>
                    <option value="channel_partner">Channel Partner</option>
                    <option value="My DB">My DB</option>
                    </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-medium text-dark mb-2">
                    Channel
                  </Form.Label>
                  <Form.Select
                    value={selectedChannel}
                    onChange={(e) => setSelectedChannel(e.target.value)}
                    className="form-select-custom"
                    style={{ width: '100%', maxWidth: '100%' }}>
                    <option value="">Select Channel</option>
                    {getChannelOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          
          <Button 
            variant="primary" 
            onClick={handleSubmitSegment}
            disabled={creating || !segmentName || !selectedDataSource || !selectedChannel}
            className="px-4 py-2"
            style={{
              backgroundColor: (creating || !segmentName || !selectedDataSource || !selectedChannel) ? '#6c757d' : '#17a2b8',
              borderColor: (creating || !segmentName || !selectedDataSource || !selectedChannel) ? '#6c757d' : '#17a2b8'
            }}
          >
            {creating ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Creating...
              </>
            ) : (
              'Next'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDelete} onHide={() => setShowDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Segment Deleted.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete "{segmentToDelete?.segment_name || segmentToDelete?.name}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDelete(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm} disabled={deleting}>
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Dynamic Filters Modal */}
      {/* <DynamicFilters
        show={showFilters}
        onHide={() => setShowFilters(false)}
        onApplyFilters={handleApplyFilters}
      /> */}
      
      </div>
      </>
    );
  };


export default SegmentListing;
